import { useState } from "react";
import { FieldValues } from "react-hook-form";
import { EditNichePopup } from "./EditNichePopup";
import { INiche } from "services/types";
import { toast } from "react-hot-toast";
import { useEditNicheMutation } from "queries";
import { EDIT_NICHE_FIELDS, getFieldsWithValues } from "./helpers";

interface IEditNichePopupContainerProps {
  niche: INiche;
  isOpen: boolean;
  onClose: () => void;
}

export const EditNichePopupContainer: React.FC<IEditNichePopupContainerProps> = ({ niche, onClose, isOpen }) => {
  const [ticketId, setTicketId] = useState<string>("");
  const editNicheMutation = useEditNicheMutation(niche.id);

  const onSubmit = async (data: FieldValues) => {
    try {
      await editNicheMutation.mutateAsync({
        id: niche.id,
        description: data.description,
        rules: data.rules,
        image: ticketId || null
      });

      onClose();
      toast.success("Successfully Updated", { duration: 5000 });
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong. Please try later", { duration: 5000 });
    }
  };

  const handleTicketId = (ticketId: string) => {
    setTicketId(ticketId);
  };

  const nicheValues = {
    name: niche.name,
    description: niche.description,
    rules: niche.rules
  };

  const nicheFields = getFieldsWithValues(EDIT_NICHE_FIELDS, nicheValues);

  return (
    <EditNichePopup
      nicheFields={nicheFields}
      onClose={onClose}
      isOpen={isOpen}
      handleTicketId={handleTicketId}
      ticketId={ticketId}
      onSubmit={onSubmit}
      preview={niche.thumbnail}
    />
  );
};
